import { API } from "@/lib/api";
import { FilterType } from "@/lib/filters";
import { StructureAssignmentForm } from "@/modules/structure-assignments/types";
import { ASSIGNMENT_TYPES } from "@/schemas/structure-assignment";
import { APIService, FetchListRequest } from "@/services/api";
import {
  ReadStructureAssignment,
  WriteStructureAssignment,
} from "@/types/structure-assignment";

const service = new APIService<ReadStructureAssignment>(
  API.StructureAssignments,
);

export const StructureAssignmentsService = {
  getList: (params: FetchListRequest<ReadStructureAssignment>) =>
    service.getList(params),

  get: async (
    supervisorId: string,
    assignmentType: ASSIGNMENT_TYPES,
  ): Promise<StructureAssignmentForm> => {
    const data = await service.getList({
      filters: [
        {
          id: "supervisor_id",
          value: {
            value: supervisorId,
            filter: FilterType.EqualsString,
          },
        },
        {
          id: "assignment_type",
          value: {
            value: assignmentType,
            filter: FilterType.EqualsString,
          },
        },
      ],
    });
    return {
      supervisor_id: supervisorId,
      supervisor_name: data.items[0]?.supervisor_name,
      assignment_type: assignmentType,
      subordinates: data.items.map(
        ({ subordinate_id, subordinate_name, comment, is_primary }) => ({
          subordinate_id,
          subordinate_name,
          comment: comment ?? "",
          is_primary: is_primary ?? false,
        }),
      ),
    };
  },

  put: (assignments: WriteStructureAssignment[]) => service.put(assignments),
};
